import PropTypes from 'prop-types';
import React from 'react';
import LocationPin from 'pubweb-smokey/dist/images/svg/iconography-16x16/location-line.svg';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';
import Button from '@components/Shared/Buttons/Button';
import { ActionButtonsStyles } from './ActionButtons.styled';
import { getLocalStorage } from 'pubweb-smokey/dist/utils/utils';

const dxReferralStates = ['SC', 'GA', 'FL'];

const ActionButtons = ({
  onRequestInfoClick,
  onFindRetailerClick,
  epicSlug,
}) => {
  const location = getLocalStorage('chUserLocation');
  const ctaHandler = React.useCallback(() => {
    if (onRequestInfoClick) {
      onRequestInfoClick();
    }

    if (epicSlug && dxReferralStates.includes(location?.state)) {
      window.open(
        `https://epic.claytonhomes.com/customize/?modelId=${epicSlug}&postalCode=${location?.postalCode}`,
        '_blank'
      );

      pushGTMEvent('gtm-chcom-dx-home-details-click', 'dx_home_details_click', {
        location: 'Home Details',
        category: 'home_consideration',
        action: 'button',
        label: 'dx_home_details_click',
      });
    }

    pushGTMEvent('requestInfoClick');
  }, [epicSlug, onRequestInfoClick, location]);

  return (
    <ActionButtonsStyles>
      <Button
        automationId="request-info-click"
        fillContainer={true}
        onClick={ctaHandler}
      >
        {epicSlug && dxReferralStates.includes(location?.state)
          ? 'Design Online'
          : 'Request Info'}
      </Button>
      <Button
        automationId="find-retailer-click"
        className="find-retailer-button"
        fillContainer={true}
        onDarkBg={true}
        onClick={() => {
          onFindRetailerClick();
          pushGTMEvent('findRetailerClick');
        }}
      >
        <span>
          <LocationPin />
          Find A Retailer
        </span>
      </Button>
    </ActionButtonsStyles>
  );
};

ActionButtons.propTypes = {
  epicSlug: PropTypes.bool,
  onFindRetailerClick: PropTypes.func,
  onRequestInfoClick: PropTypes.func,
};

export default ActionButtons;
